<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="222"> </caass-schoolselector>
						</div>
					</div>

					<!--GradeLevelID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade Level</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GradeLevelID" [(ngModel)]="report.GradeLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GradeLevelList" [ngValue]="o.GradeLevelID">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--AcademyID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AcademyID" [(ngModel)]="report.AcademyID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of AcademyList" [ngValue]="o.AcademyId">
									{{ o.AcademyDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--HomeroomID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="HomeroomID" [(ngModel)]="report.HomeroomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of HomeroomList" [ngValue]="o.HomeroomId">
									{{ o.HomeRoom }}
								</option>
							</select>
						</div>
					</div>

					<!--ORDERBY-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ORDERBYID" [(ngModel)]="report.ORDERBYID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ORDERBYList" [ngValue]="o.ORDERBYName">
									{{ o.ORDERBYName }}
								</option>
							</select>
						</div>
					</div>

					<!--W_ID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show ID</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_ID" [(ngModel)]="report.W_ID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_List" [ngValue]="o.W_ID">
									{{ o.W_ID }}
								</option>
							</select>
						</div>
					</div>

					<!--W_HPhone-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Home Phone</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_HPhoneID" [(ngModel)]="report.W_HPhoneID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_HPhoneList" [ngValue]="o.W_HPhoneID">
									{{ o.W_HPhoneID }}
								</option>
							</select>
						</div>
					</div>

					<!--W_HRoom-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_HRoomID" [(ngModel)]="report.W_HRoomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_HRoomList" [ngValue]="o.W_HRoomID">
									{{ o.W_HRoomID }}
								</option>
							</select>
						</div>
					</div>

					<!--W_DOB-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Date of Birth</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_DOBID" [(ngModel)]="report.W_DOBID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_DOBList" [ngValue]="o.W_DOBID">
									{{ o.W_DOBID }}
								</option>
							</select>
						</div>
					</div>

					<!--W_Name-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Name</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_NameID" [(ngModel)]="report.W_NameID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_NameList" [ngValue]="o.W_NameID">
									{{ o.W_NameID }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
